import template from './new.html';
import { STATES } from '../../../../constants';
import { actions, selectors } from '../../../../state';
import './new.global.css';

const TOAST_ERROR = 'Sorry. There was an error saving your move.';

class NewMoveController {
  constructor(updStore) {
    'ngInject';
    const { connect, dispatch } = updStore;

    Object.assign(this, {
      connect,
      dispatch,
      move: {},
    });
  }

  $onInit() {
    this.disconnect = this.connect(mapStateToThis)(this);
  }

  $onDestroy() {
    this.disconnect();
  }

  onSubmitted({ move }) {
    const { dispatch } = this;
    const success = ({
      meta: {
        response: {
          data: {
            data: { id },
          },
        },
      },
    }) =>
      dispatch(
        actions.router.stateGo(STATES.DASHBOARD_NEW_MOVE, {
          moveId: id,
        })
      );
    const error = () => dispatch(actions.message.error(TOAST_ERROR));

    const body = { ...move, confirmed: true };
    dispatch(actions.move.create(body)).then(success, error);
  }
}

function mapStateToThis(state) {
  return {
    submitting: selectors.pending.match(actions.move.isCreate, state),
  };
}

export const NewMoveComponent = {
  template,
  controller: NewMoveController,
};
